/** @format */

export const productTags: string[] = [
	'Meat',
	'Milk products',
	'Vegetables',
	'Fruits',
	'Snacks',
	'Tea and coffee',
	'Alcohol',
];
